// import Config from 'Config'; // eslint-disable-line import/no-unresolved
import api from './api';

class Endpoint {
  constructor(path, request, receive) {
    this.server = '/';
    this.path = path;
    this.request = request;
    this.receive = receive;
    this.method = 'GET';

    if (this.path[0] === '/') {
      this.path = this.path.substring(1);
    }
  }

  withMethod(method) {
    this.method = method;
    return this;
  }

  withBody(body) {
    this.body = body;
    return this;
  }

  withMock(mock) {
    this.mock = mock;
    return this;
  }

  withOptions(options) {
    this.debugSleep = options.debugSleep;
    this.onError = options.onError;
    return this;
  }

  sleep(time) {
    return new Promise(resolve => setTimeout(resolve, time));
  }

  doMock(dispatch) {
    console.log(
      `Using mock data for ${this.method} ${this.server}${this.path}`
    );
    if (this.mock instanceof Function) {
      this.mock(dispatch);
    } else {
      dispatch(this.receive(this.mock));
    }
  }

  call() {
    const url = `${this.server}${this.path}`;
    if (this.server && this.path && this.request && this.receive) {
      return dispatch => {
        dispatch(this.request());
        return this.sleep(this.debugSleep || 0)
          .then(() => {
            if (this.mock) {
              return this.doMock(dispatch);
            }
            return api(
              dispatch,
              url,
              this.method,
              this.body,
              this.receive,
              this.onError
            );
          })
          .catch(err => {
            console.warn(err);
          });
      };
    }
    console.warn('Missing path, server, request or receive');
    return null;
  }
}

export default Endpoint;
